const colors = {
  default: 'gray',
  action: 'inherit',
  module: '#03A9F4',
  resource: '#4CAF50',
};
/**
 * 生成样式
 * @param {string} type 颜色类型
 * @param {string} weight 字重
 */
function style(type, weight = 'bold') {
  return `color: ${colors[type]}; font-weight: ${weight}`;
}
/**
 * 日志输出
 * @param {boolean} silent
 */
export default function createLogger(silent = true) {
  /**
   * @param {string} action
   * @param {object} params
   */
  return function (action, params = null) {
    if (silent) {
      return;
    }
    const type = params ? params.f_type : -1;
    console.groupCollapsed(
      `%c[reporter] %c(${type === 0 ? 'pv' : action}${type === 1 ? '.module' : ''})`,
      style('default', 'lighter'),
      style('action'),
    );
    if (params) {
      if (params.f_module) {
        console.log('%c f_module:', style('module'), params.f_module);
      }
      if (params.f_resource) {
        console.log('%c f_resource:', style('resource'), params.f_resource);
      }
      console.table(params);
    }
    console.groupEnd();
  }
}
